<template>
  <div class="my-4 rounded-lg border-2 border-light-gray px-4 py-2">
    <div class="grid grid-cols-5 items-center">
      <div class="col-span-4 flex flex-col md:flex-row">
        <h3
          class="flex-1 text-left text-1lg leading-tight text-placeholder-gray"
        >
          {{ request.carrier.legal_name }}
        </h3>
        <p class="py-1 text-left text-xxs text-placeholder-gray md:pl-2">
          {{ identifiers }}
        </p>
      </div>
      <div class="self-start justify-self-end">
        <status-button
          size="xs"
          value="pending"
        />
      </div>
    </div>
    <p class="text-left text-xxs text-placeholder-gray">
      Request Sent by {{ creatorName }} at {{ createdHour }} on
      {{ createdDate }}
    </p>
  </div>
</template>
<script>
import moment from 'moment';

import StatusButton from '@/components/StatusButton.vue';

export default {
  name: 'PendingRequestCard',
  components: {
    StatusButton,
  },
  props: {
    request: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    identifiers() {
      const identifiersList = this.request.carrier.identifiers.map(
        (identifier) => {
          return `${identifier.is_type}# ${identifier.value}`;
        }
      );
      return identifiersList.join(' - ');
    },
    creatorName() {
      return `${this.request.creator.first_name} ${this.request.creator.last_name}`;
    },
    createdDate() {
      return this.displayDate(this.request.created_at);
    },
    createdHour() {
      return this.displayHour(this.request.created_at);
    },
  },
  async created() {},
  methods: {
    displayDate(date) {
      if (date) {
        return moment(date, 'YYYY-MM-DD').format('M/D/YY');
      }
    },
    displayHour(date) {
      if (date) {
        return moment(date).format('h:mm A');
      }
    },
  },
};
</script>
<style scoped></style>
